import React, { ReactNode } from 'react'

interface Props {
    children: ReactNode
}
const Content = ({ children }: Props) => {
    return <div className="w-[81%] mx-auto">{children}</div>
}

export default Content
